module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "custom-select",
    class: {
      open: _vm.open,
      disabled: _vm.disabled
    },
    attrs: {
      "tabindex": _vm.tabindex
    },
    on: {
      "blur": function($event) {
        _vm.open = false
      }
    }
  }, [_c('div', {
    staticClass: "selected flex middle-xs justify-between items-center pl-small",
    class: {
      open: _vm.open
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        !_vm.disabled ? (_vm.open = !_vm.open) : null
      }
    }
  }, [(_vm.selected) ? _c('span', {
    staticClass: "pl-small truncate-text"
  }, [_vm._v(_vm._s(_vm.label ? _vm.selected[_vm.label] : _vm.selected))]) : _c('span', {
    staticClass: "text-sm text-gray-300 truncate-text"
  }, [_vm._v(_vm._s(_vm.placeholder))]), _vm._v(" "), _c('div', {
    staticClass: "flex"
  }, [(_vm.isLoading) ? _c('pl-spinner', {
    staticClass: "spinner-style"
  }) : _vm._e(), _vm._v(" "), (_vm.arrow) ? _c('i', {
    staticClass: "fas fa-angle-down text-gray-400 text-lg"
  }) : _vm._e()], 1)]), _vm._v(" "), _c('div', {
    staticClass: "items",
    class: {
      selectHide: !_vm.open
    }
  }, _vm._l((_vm.options), function(option, index) {
    return _c('div', {
      key: index,
      staticClass: "option-item",
      on: {
        "click": function($event) {
          _vm.open = false;
          _vm.$emit('change', option);
        }
      }
    }, [(_vm.cardHeader) ? _vm._t("default", null, {
      "index": index
    }) : _c('span', [_vm._v(_vm._s(_vm.label ? option[_vm.label] : option))])], 2)
  }), 0)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler.js?id=data-v-b0c54fbe!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/app/components/material/components/plSelect/plSelect.vue
// module id = 2378
// module chunks = 61